module.exports = __webpack_public_path__ + "static/media/6_Doklad_vazn_20150626pdf.fd4e6c8a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/6_Doklad_vazn_20150626pdf.pdf
// module id = 189
// module chunks = 0